import * as React from 'react';
import { SVGProps } from 'react';

export function SuccessIcon(props: SVGProps<SVGSVGElement>) {
  const { fill, color = 'white' } = props;

  return (
    <svg
      style={{ width: 'inherit', height: 'inherit' }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33337 7.99992C1.33337 4.31802 4.31814 1.33325 8.00004 1.33325C11.6819 1.33325 14.6667 4.31802 14.6667 7.99992C14.6667 11.6818 11.6819 14.6666 8.00004 14.6666C4.31814 14.6666 1.33337 11.6818 1.33337 7.99992ZM11.1096 5.83498C11.3848 6.07959 11.4096 6.50097 11.165 6.77619L7.60944 10.7762C7.48291 10.9185 7.30157 10.9999 7.11117 10.9999C6.92071 10.9999 6.73937 10.9185 6.61288 10.7762L4.8351 8.77618C4.59049 8.50098 4.61527 8.07958 4.89047 7.83498C5.16565 7.59038 5.58703 7.61518 5.83165 7.89032L7.11117 9.32978L10.1684 5.89034C10.413 5.61515 10.8344 5.59037 11.1096 5.83498Z"
        fill={color}
      />
      <path
        d="M11.1096 5.83515C11.3847 6.07976 11.4095 6.50114 11.1649 6.77636L9.38713 8.77636L7.60937 10.7764C7.48283 10.9187 7.3015 11.0001 7.1111 11.0001C6.92063 11.0001 6.7393 10.9187 6.61281 10.7764L4.83503 8.77636C4.59041 8.50116 4.6152 8.07976 4.89039 7.83516C5.16558 7.59056 5.58696 7.61536 5.83157 7.89049L7.1111 9.32996L10.1684 5.89052C10.413 5.61532 10.8344 5.59054 11.1096 5.83515Z"
        fill={fill}
      />
    </svg>
  );
}
